import { theme } from '@kvdbil/components';
import { ReactNode } from 'react';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider } from 'styled-components';
import { store } from '../data/store';
import { BugsnagErrorBoundary } from './Bugsnag';
import GlobalStyles from './GlobalStyles';
import { TranslationProvider } from './Translations';

interface ProvidersProps {
  children: ReactNode;
}

const Providers = ({ children }: ProvidersProps) => {
  return (
    <BugsnagErrorBoundary>
      <TranslationProvider>
        <ThemeProvider theme={theme}>
          <Provider store={store}>
            <BrowserRouter>
              <GlobalStyles />
              {children}
            </BrowserRouter>
          </Provider>
        </ThemeProvider>
      </TranslationProvider>
    </BugsnagErrorBoundary>
  );
};

export default Providers;
